<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑视频号' : '创建视频号'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 视频号ID -->
      <a-form-item
        label="视频号ID"
        name="wx_finder_id"
        :rules="[{ required: true, message: '请输入'  }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.wx_finder_id"
          :disabled="!!id"
        />
      </a-form-item>
      <!-- 视频号名称 -->
      <a-form-item
        label="视频号名称"
        name="name"
        :rules="[{ required: true, message: '请输入'  }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.name"
        />
      </a-form-item>
      <!-- 撮合服务商 -->
      <a-form-item
        label="撮合服务商"
        name="provider_id"
      >
        <a-select
          v-model:value="formState.provider_id"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in suppliers" :key="item.provider_id" :value="item.provider_id">{{ item.provider_name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 姓名 -->
      <a-form-item
        label="姓名"
        name="real_name"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.real_name"
        />
      </a-form-item>
      <!-- 身份证 -->
      <a-form-item
        label="身份证"
        name="id_number"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.id_number"
        />
      </a-form-item>
      <!-- 银行卡号 -->
      <a-form-item
        label="银行卡号"
        name="bank_account"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.bank_account"
        />
      </a-form-item>
      <!-- 手机号 -->
      <a-form-item
        label="手机号"
        name="phone"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.phone"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import dayjs from 'dayjs'
import { finderProviderAll, finderDarenSave } from '@/api/copyright'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// id
let id = ref(null)
// 撮合服务商列表
let suppliers = ref([])
// 表单
let formState = reactive({
  // 撮合服务商
  provider_id: [],
  // 视频号ID
  wx_finder_id: undefined,
  // 视频号名称
  name: undefined,
  // 姓名
  real_name: undefined,
  // 身份证
  id_number: undefined,
  // 银行卡号
  bank_account: undefined,
  // 手机号
  phone: undefined
})

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // 赋值
  nextTick(() => {
    // id
    id.value = params.id
    // 撮合服务商
    formState.provider_id = params.provider_id
    // 视频号ID
    formState.wx_finder_id = params.wx_finder_id
    // 视频号名称
    formState.name = params.name
    // 姓名
    formState.real_name = params.real_name
    // 身份证
    formState.id_number = params.id_number
    // 银行卡号
    formState.bank_account = params.bank_account
    // 手机号
    formState.phone = params.phone
    // 获取选择项列表
    getSelectList()
  })
}

// 获取选择项列表
function getSelectList () {
  finderProviderAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      suppliers.value = data
    }
  })
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 重置
    RefForm.value.resetFields()
    id.value = undefined
    visible.value = false
  }
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      id: id.value,
      ...formState,
      wx_finder_id: (formState.wx_finder_id || '').trim()
    }
    finderDarenSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>